import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "./store/state";
import routes from "./Router/routes";
import bottomRoutes from "./Router/bottomRoutes";
import { Container } from "@mui/material";
import theme from "./theme/theme";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./Router/PrivateRoute";
import { MainLayout } from "./layouts";
import Signup from "./views/auth/Signup";
import Signin from "./views/auth/Signin";
import Page404 from "./views/page404/Page404";
import { LocalRouteProps } from "./index.d";
import ForgotPassword from "./views/auth/ForgotPassword";
import BossProfile from "./views/boss/BossProfile";
import BaraForm from "./views/bara/BaraForm";
import TransactionForm from "./views/transaction/TransactionForm";
import Notifications from "./views/notifications/Notifications";
import TransactionDetail from "./views/transaction/TransactionDetail";
import BaraDetail from "./views/bara/BaraDetail";
import Offres from "./views/offres/OffresRedirect";

function App() {
  const user = useSelector((state: RootState) => state.auth.user);

  const all_routes: LocalRouteProps[] = [...routes, ...bottomRoutes];

  return (
    <Container
      style={{
        padding: 0,
        margin: "unset",
        backgroundColor: theme.colors.white,
        maxWidth: "100%",
      }}
    >
      <Routes>
        {!user ? (
          <>
            <Route path={"/"} element={<Signin />} />
            <Route path={"/signin"} element={<Signin />} />
            <Route path={"/signup"} element={<Signup />} />
            <Route path={"/forgot-password"} element={<ForgotPassword />} />
            <Route path={"*"} element={<Navigate to="/signin" />} />
            <Route path={"/offres"} element={<Offres />} />
          </>
        ) : (
          <Route
            path={"/"}
            element={
              <PrivateRoute>
                <MainLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/accueil" />} />
              {all_routes.map((route, index) => (
                <Route
                  path={route.path}
                  element={route.component}
                  key={index}
                >
                  {route?.children?.map((r, ind) => (
                    <Route
                      path={r.path}
                      element={r.component}
                      key={ind}
                    />
                  ))}
                  <Route
                    index
                    element={
                      <Navigate
                        to={`${
                          route.name === "home" ? "accueil" : "gestion-mot-pass"
                        }`}
                      />
                    }
                  />
                  <Route
                    path="*"
                    element={
                      <Navigate
                        to={`${
                          route.name === "home" ? "accueil" : "gestion-mot-pass"
                        }`}
                      />
                    }
                  />
                </Route>
              ))}
            <Route path={'/user-profile'} element={<BossProfile />} />
            <Route path={'/bara/bara-form'} element={<BaraForm />} />
            <Route path={'/bara/bara-detail/:id'} element={<BaraDetail />} />
            <Route path={'/boss/profile/:id'} element={<BossProfile />} />
            <Route path={'/transactions/add'} element={<TransactionForm />} />
            <Route path={'/transactions/detail/:id'} element={<TransactionDetail />} />
            <Route path={'/notifications'} element={<Notifications />} />
          </Route>
        )}
        {user ? <Route path="*" element={<Page404 />} /> : null}
      </Routes>
    </Container>
  );
}

export default App;
